import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import * as styles from "./styles.module.scss";

const messages = defineMessages( {
	trusted: {
		id: "login.highlights.trusted",
		defaultMessage: "Trusted by 13+ million websites",
	},
	title: {
		id: "login.highlights.title",
		defaultMessage: "Every site you run and everything you need to grow.",
	},
	brandInsights: {
		id: "login.highlights.brandInsights",
		defaultMessage: "Brand insights",
	},
	academy: {
		id: "login.highlights.academy",
		defaultMessage: "Yoast Academy",
	},
	licenseManagement: {
		id: "login.highlights.licenseManagement",
		defaultMessage: "Subscription management",
	},
} );

const pills = [ messages.brandInsights, messages.academy, messages.licenseManagement ];

/**
 * What MyYoast offers, shown on top of the animated background right of the login bar.
 *
 * Its id is a stable hook for A/B tests, as the CSS Module class names are hashed; keep it unchanged.
 *
 * @returns {ReactElement} The login highlights.
 */
const LoginHighlights = () => (
	<div id="login-highlights" className={ styles.highlights }>
		<p className={ styles.highlightsBadge }>
			<span className={ styles.highlightsDot } aria-hidden="true" />
			<FormattedMessage { ...messages.trusted } />
		</p>
		<p className={ styles.highlightsTitle }>
			<FormattedMessage { ...messages.title } />
		</p>
		<ul className={ styles.highlightsPills }>
			{ pills.map( message => (
				<li key={ message.id } className={ styles.highlightsPill }>
					<FormattedMessage { ...message } />
				</li>
			) ) }
		</ul>
	</div>
);

export default LoginHighlights;
